/**
 * CornerHint – manages the fixed-position control-hint overlay
 * displayed in the bottom-right corner of the screen.
 */
export class CornerHint {
  private el: HTMLDivElement;

  constructor() {
    this.el = document.createElement("div");
    this.el.style.cssText = [
      "position:fixed",
      "bottom:20px",
      "right:20px",
      "color:rgba(255,255,255,0.45)",
      "font-size:13px",
      "font-family:sans-serif",
      "pointer-events:none",
      "z-index:9998",
      "text-align:right",
      "line-height:1.8",
      "transition:opacity 0.4s",
    ].join(";");
    document.body.appendChild(this.el);
    this.showUnlocked();
  }

  private b(text: string, color = "rgba(255,255,255,0.65)"): string {
    return `<b style="color:${color}">${text}</b>`;
  }

  showUnlocked(): void {
    this.el.innerHTML = [
      `${this.b("Click")} to look around`,
      `${this.b("W A S D")} to move &nbsp;·&nbsp; ${this.b("Shift")} to run`,
      `${this.b("Scroll")} to zoom &nbsp;·&nbsp; zoom in fully for first person`,
      `${this.b("Esc")} to release mouse`,
    ].join("<br>");
  }

  showLocked(): void {
    this.el.innerHTML = [
      `${this.b("W A S D")} to move &nbsp;·&nbsp; ${this.b("Shift")} to run`,
      `${this.b("Space")} to jump &nbsp;·&nbsp; ${this.b("B")} to dance`,
      `${this.b("Scroll")} to zoom &nbsp;·&nbsp; zoom in fully for first person`,
      `${this.b("Esc")} to release mouse`,
    ].join("<br>");
  }

  showFirstPerson(): void {
    this.el.innerHTML = [
      `${this.b("First Person Mode", "rgba(255,180,80,0.9)")}`,
      `${this.b("Scroll up")} to switch to third person to move`,
      `${this.b("Esc")} to release mouse`,
    ].join("<br>");
  }

  dispose(): void {
    this.el.remove();
  }
}
